<div class="upload-container">
    <div *ngIf="showProgress" class="progress-container">
        <app-progress
            *ngIf="progress && progress > 0"
            [percent]="progress"
            [strokeWidth]="12"
            nzStrokeColor="#28A745"
            [showInfo]="true"
        ></app-progress>
    </div>

    <nz-upload
        [nzRemove]="handleRemove"
        [(nzFileList)]="fileList"
        [nzListType]="listType"
        [nzMultiple]="multiple"
        [nzShowUploadList]="showUploadList"
        [nzType]="nzType"
        [nzDisabled]="disabled"
        [nzShowButton]="fileList.length < (multiple ? (fileLimit || 99999) : 1)"
        [nzPreview]="canPreview ? handlePreview : null"
        [nzBeforeUpload]="beforeUpload"
        class="nz-upload"
    >
        <nz-spin [nzSpinning]="loading">
            <ng-container *ngIf="render">
                <ng-container
                    *ngTemplateOutlet="render"></ng-container>
            </ng-container>

            <ng-container *ngIf="!render">
                <button nz-button [disabled]="disabled">
                    <em nz-icon nzType="upload"></em>
                    {{ buttonText }}
                </button>
            </ng-container>
        </nz-spin>
    </nz-upload>
</div>

<div *ngIf="progress > 0 && canRemove && showUploadList" class="upload-progress">
    <app-progress
        [percent]="progress"
        [strokeWidth]="12"
        nzStrokeColor="#28A745"
        [showInfo]="true"
        class="progress"
    ></app-progress>

    <button
        nz-button
        class="text-btn-danger"
        nzSize="mini"
        (click)="cancelRequest()"
    >
        Cancel
    </button>
</div>

<nz-modal
        [nzVisible]="previewVisible"
        [nzContent]="modalContent"
        [nzFooter]="null"
        (nzOnCancel)="previewVisible = false"
        nzWidth="900px"
>
    <ng-template #modalContent>
        <nz-spin [nzSpinning]="previewLoading" class="image-box">
            <img nz-image [src]="previewImage" style="width: 100%" />
        </nz-spin>
    </ng-template>
</nz-modal>

<app-confirm-dialog
    [isVisible]="isVisible"
    [cancelLoading]="cancelLoading"
    [overwriteLoading]="overwriteLoading"
    [keepLoading]="keepLoading"
    (close)="handleCancel()"
    (submitSuccess)="fileSubmit($event)"
></app-confirm-dialog>

